var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting_content" }, [
    _c("div", { staticClass: "setting_content_main" }, [
      _c("div", { staticClass: "setting_content_heading" }, [
        _c("div", { staticClass: "setting_content_heading_btn" }, [
          _c(
            "button",
            {
              staticClass: "setting_btn_secondary setting_btn_medium",
              on: { click: _vm.updateRedisData }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.labelProperties.BUTTON_UPDATE_REDIS_DATA) +
                  "\n        "
              )
            ]
          )
        ])
      ]),
      _c("div", { staticClass: "setting_content_heading_btn mt-3" }, [
        _c(
          "button",
          {
            staticClass: "setting_btn_secondary setting_btn_medium",
            on: { click: _vm.resetMasterData }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.labelMasterProperties.BUTTON_RESET_MASTER_DATA) +
                "\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }